import React, { useEffect, useState } from 'react';

function TerminalBlock({ command, title = 'terminal', language = 'bash' }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) {
      return undefined;
    }

    const timeout = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(timeout);
  }, [copied]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(command);
      setCopied(true);
    } catch (error) {
      setCopied(false);
    }
  };

  return (
    <figure className="group my-6 overflow-hidden rounded-2xl border border-ink-700/80 bg-[#0b0f19] shadow-soft">
      <figcaption className="flex items-center justify-between border-b border-ink-700/70 bg-[#111827] px-4 py-2">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1.5" aria-hidden="true">
            <span className="h-2.5 w-2.5 rounded-full bg-red-400" />
            <span className="h-2.5 w-2.5 rounded-full bg-amber-300" />
            <span className="h-2.5 w-2.5 rounded-full bg-emerald-400" />
          </div>
          <span className="text-xs font-medium uppercase tracking-[0.16em] text-ink-300">
            {title}
          </span>
        </div>

        <button
          type="button"
          onClick={handleCopy}
          className="rounded-md border border-ink-600 bg-[#1c2433] px-3 py-1 text-xs font-semibold text-ink-100 transition hover:border-ink-400 hover:bg-[#273146]"
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </figcaption>

      <div className="overflow-x-auto px-4 py-4">
        <pre className="min-w-max font-mono text-sm leading-7 text-slate-100">
          <code className={`language-${language}`}>{command}</code>
        </pre>
      </div>
    </figure>
  );
}

export default TerminalBlock;
